export default "__VITE_ASSET__MwyFy24A__"